import React from 'react';
import { pluralize } from 'swag-common/utils/strings';
import { SingleViewDesignUpload } from '../single-view-design-upload';
import { NonVectorImageUploadPopup } from '../non-vector-image-upload-popup';
import { CompanyArtFolderPopup } from '../../../../../popups/company-art-folder-popup';
import { CompanyArtFolderAllLogosPopup } from '../../../../../popups/company-art-folder-all-logos-popup';
import { DeleteArtFolderLogoPopup } from '../../../../../popups/delete-art-folder-logo-popup';
import classes from '../details/details.scss';
export const DesignUploadPanelComponent = ({
  maxPrintColors,
  shouldShowMaxPrintColorsMessage,
  printingProcessDescription,
  productViews,
  isLimitedEdition = false
}) => {
  const colorText = pluralize(maxPrintColors, 'color', 's', true);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.fullWidth
  }, /*#__PURE__*/React.createElement("p", null, "Maximum file size ", /*#__PURE__*/React.createElement("strong", null, "10Mb"), ". For best results please upload an EPS file.", shouldShowMaxPrintColorsMessage && ` This product allows ${maxPrintColors} ${colorText} to print`), printingProcessDescription && /*#__PURE__*/React.createElement("p", null, printingProcessDescription), productViews.map(view => /*#__PURE__*/React.createElement(SingleViewDesignUpload, {
    key: view.id,
    view: view,
    isLimitedEdition: isLimitedEdition
  })), /*#__PURE__*/React.createElement(NonVectorImageUploadPopup, null), /*#__PURE__*/React.createElement(CompanyArtFolderPopup, null), /*#__PURE__*/React.createElement(CompanyArtFolderAllLogosPopup, null), /*#__PURE__*/React.createElement(DeleteArtFolderLogoPopup, null));
};